import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { Locale } from "@/lib/i18n/config";
import { CategoriesClient } from "@/modules/categories/components/CategoriesClient";
import { useCategoriesQuery } from "@/shared/services/useCategoriesQuery";

type SellerCategoriesPageClientProps = {
  locale: Locale;
  storeSlug: string;
  showSaveNotice: boolean;
  defaultCreateOpen: boolean;
  defaultEditId: string | null;
};

export function CategoriesPage({
  locale,
  storeSlug,
  showSaveNotice,
  defaultCreateOpen,
  defaultEditId,
}: SellerCategoriesPageClientProps) {
  const t = useTranslations();
  const { data, isLoading, error } = useCategoriesQuery({ storeSlug });

  if (isLoading && !data) {
    return (
      <div className="text-sm text-[color:var(--text-muted)]">
        {t(keys.common.loading)}
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-sm text-[color:var(--text-muted)]">
        {t(keys.errors.generic)}
      </div>
    );
  }

  return (
    <CategoriesClient
      locale={locale}
      storeSlug={storeSlug}
      categories={data ?? []}
      showSaveNotice={showSaveNotice}
      defaultCreateOpen={defaultCreateOpen}
      defaultEditId={defaultEditId}
    />
  );
}
